import React from "react";
import { Phone, ArrowRight } from "lucide-react";
import { company } from "../mock";

const CTABanner = () => {
  const scrollTo = (id) => {
    const el = document.getElementById(id);
    if (el) window.scrollTo({ top: el.getBoundingClientRect().top + window.scrollY - 78, behavior: "smooth" });
  };

  return (
    <section className="py-16" style={{ background: "var(--orange)" }}>
      <div className="max-w-7xl mx-auto px-6 flex flex-col md:flex-row items-center justify-between gap-8 text-center md:text-left">
        <div>
          <p className="text-white/90 font-semibold tracking-widest uppercase text-sm">
            Quality Care &middot; Peace of Mind
          </p>
          <h3 className="font-display font-bold text-white text-[30px] sm:text-[40px] mt-2 leading-tight">
            Be smart, help yourself or a loved one now!
          </h3>
        </div>
        <div className="flex flex-col sm:flex-row items-center gap-4 shrink-0">
          <a
            href={`tel:${company.phoneLink}`}
            className="inline-flex items-center gap-3 bg-white text-[#c96612] px-7 py-4 rounded-full font-bold text-lg shadow-lg hover:-translate-y-1 transition-transform"
          >
            <Phone size={22} /> {company.phone}
          </a>
          <button
            onClick={() => scrollTo("contact")}
            className="inline-flex items-center gap-2 border-2 border-white text-white px-7 py-4 rounded-full font-semibold hover:bg-white hover:text-[#c96612] transition-colors"
          >
            Free Consultation <ArrowRight size={18} />
          </button>
        </div>
      </div>
    </section>
  );
};

export default CTABanner;
